import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { profilesSelector } from 'redux/reducers/profiles';
import { profileTypesSelector } from 'redux/reducers/profileTypes';
import ProfileTypeCard from './ProfileTypeCard/ProfileTypeCard';
import './styles.less';

const ProfileTypeForm = ({ onChange, initValue = null, onSubmit }) => {
  const [selectedProfileType, setSelectedProfileType] = React.useState(0);
  const profileList = useSelector(profilesSelector);
  const profileTypeList = useSelector(profileTypesSelector);

  const usedProfileTypes = profileList
    .filter((profile) => {
      const profileType = profileTypeList.find((pt) => pt.profileTypeId === profile.profileTypeId);
      return profileType?.multiConfigAllowed === false;
    })
    .map((profile) => profile.profileTypeId);
  const handleCardClick = (profileTypeId) => {
    if (profileTypeId !== selectedProfileType) {
      setSelectedProfileType(profileTypeId);
      onChange(profileTypeId);
    } else {
      onSubmit();
    }
  };

  React.useEffect(() => {
    if (initValue !== null) {
      setSelectedProfileType(initValue);
    }
  }, [initValue]);

  return (
    <Row
      type="flex"
      align="middle"
      justify="space-around"
      gutter={[
        { xs: 16, sm: 16, md: 16, lg: 16 },
        { xs: 16, sm: 16, md: 16, lg: 16 },
      ]}
    >
      {profileTypeList.map((profileType) => (
        <Col
          key={profileType.profileTypeId}
          span={8}
          className="profile-type-form__col"
          xs={24}
          sm={12}
          md={8}
          lg={8}
          xl={8}
          xxl={8}
        >
          <ProfileTypeCard
            profileType={profileType}
            onClick={handleCardClick}
            selected={profileType.profileTypeId === selectedProfileType}
            disabled={usedProfileTypes.includes(profileType.profileTypeId)}
          />
        </Col>
      ))}
    </Row>
  );
};

ProfileTypeForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  initValue: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

ProfileTypeForm.defaultProps = {
  initValue: '',
};

export default ProfileTypeForm;
